export default "__VITE_ASSET__f555db77__"